var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('dashboard-dropdown-section',{attrs:{"title":"Booking History","type":"locum-booking-history","items-shown":5,"items":_vm.bookings,"event-name":"load-locum-booking-history"},on:{"load-locum-booking-history":_vm.loadMore}})}
var staticRenderFns = []

export { render, staticRenderFns }